import React from "react";


const SyncIcon = props => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14.83" height="16.9" viewBox="0 0 14.83 16.9">
        <g id="_9035964_refresh_sharp_icon" data-name="9035964_refresh_sharp_icon" transform="translate(-95.25 -56.939)">
          <path id="Path_417" data-name="Path 417" d="M103.928,134.425s.862-.425-2.265-.425a5.663,5.663,0,1,0,5.663,5.663" transform="translate(0 -73.31)" fill="none" stroke="#fff" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1.5"/>
          <path id="Path_418" data-name="Path 418" d="M256,58l2.832,2.832L256,63.663" transform="translate(-154.337)" fill="none" stroke="#fff" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1.5"/>
        </g>
      </svg>
      




    );

}

export default SyncIcon;